import React, { Component } from 'react';

import { Accordion } from 'react-bootstrap';

// Import Style
import './Filter.scss';

class FilterPlaceholder extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Accordion alwaysOpen className='filter'>
        <Accordion.Item eventKey="controls">
          <Accordion.Header>
            <React.Fragment><span className='title'>Controls</span></React.Fragment>
          </Accordion.Header>
          <Accordion.Body></Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="filters">
          <Accordion.Header>
            <React.Fragment><span className='title'>Filters</span></React.Fragment>
          </Accordion.Header>
          <Accordion.Body></Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
}
export default FilterPlaceholder;
